/*
 |------------------------------------------------------------------------------
 | Tag Manager utility
 |------------------------------------------------------------------------------
 |
 | This utility serves as a facade layer between Google Tag Manager integration
 | and the JavaScript code base.
 |
 */

export function push(data) {
    if(!window.dataLayer || !data) {
        return false;
    }

    window.dataLayer.push(data);
}
